import { motion } from "framer-motion";

export const AnimatedSection = ({ children, className = "", delay = 0, y = 28, ...props }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.65, delay, ease: [0.16, 1, 0.3, 1] }}
    {...props}
  >
    {children}
  </motion.div>
);
